import Quill from 'quill'

let Inline = Quill.import('blots/inline');
let Block = Quill.import('blots/block');
let Embed = Quill.import('blots/embed')

// class LinkBlot extends Embed {
//   static create(link) {
//     let node = super.create();
//     console.log("Creating a link")
//     node.setAttribute('href', link.linkURL);
//     node.setAttribute('target', '_blank');
//     return node;
//   }
  
//   static formats(node) {
//     return node.getAttribute('href');
//   }
// }
// LinkBlot.blotName = 'linkBlot';
// LinkBlot.tagName = 'a';
// LinkBlot.className = 'link-blot-class'

// class HeaderBlot extends Block {
//   static create(header) { 
//     let node = super.create();
//     node.setAttribute('header', header);
//     console.log(header)
//     console.log(node)
//     HeaderBlot.tagName.indexOf(node.tagName) + 1
//     return node;
//   }
//   static formats(node) {
//     return {
//       value: node.getAttribute('header'),
//       tag: HeaderBlot.tagName.indexOf(node.tagName) + 1,
//     }
//   }	
  
// 	static value(node) {
// 		return {
// 			name: node.getAttribute('header'),
// 		}
// 	}
// }
class HeaderBlot extends Block {

  static formats(node) {
    return HeaderBlot.tagName.indexOf(node.tagName) + 1  
  }		
}
HeaderBlot.blotName = 'header';
HeaderBlot.tagName = ['H1', 'H2', 'H3', 'H4', 'H5'];
HeaderBlot.className = 'header-blot-class';

// export default {LinkBlot, HeaderBlot}
export default HeaderBlot
// class BoldBlot extends Inline { 
//     static create(bold) {
//         let node = super.create()
//         node.classList.add('bold-blot')
//         node.setAttribute('title', bold)
//         node.setAttribute('tag',  'b')
// 		return node
//     }
//     // Goes to delta.attributes
// 		static formats(node) {
// 			return {
// 				tag: node.getAttribute('tag'),
// 			}
//     }
//     static value(node) {
// 			return {
//         tag: node.getAttribute('tag'),
//         value: node.getAttribute('title'),
// 			}
// 		}
// }
// BoldBlot.blotName = 'boldBlot';
// BoldBlot.tagName = 'strong';
// BoldBlot.className = 'bold-blot-class';

// class ItalicBlot extends Inline {
//     static create(italic) {
//       let node = super.create()
//       node.classList.add('italic-blot')
//       node.setAttribute('title', italic)
//       node.setAttribute('tag',  'em')
//       return node
//     }
//         // Goes to delta.attributes
//         static formats(node) {
//           return {
//             tag: node.getAttribute('tag'),
//           }
//         }
//         static value(node) {
//           return {
//             tag: node.getAttribute('tag'),
//             value: node.getAttribute('title'),
//           }
//         }
// }


// ItalicBlot.blotName = 'italicBlot';
// ItalicBlot.tagName = 'em';
// ItalicBlot.className = 'italic-blot-class';

// // export default {BoldBlot, ItalicBlot}
// export {BoldBlot, ItalicBlot}
